var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "post contact" },
    [
      _c(
        "d-main-image",
        _vm._b(
          { on: { load: _vm.pageLoaded } },
          "d-main-image",
          { img: _vm.img, show: _vm.show },
          false
        )
      ),
      _c("w-go-down"),
      _c("k-main", { attrs: { title: _vm.title } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }